export function updateObjectInArray<T>(
  array: T[],
  itemToUpdate: T,
  update: Partial<T>
) {
  return array.map((item) => {
    if (item !== itemToUpdate) {
      return item;
    }

    return {
      ...itemToUpdate,
      ...update,
    };
  });
}
